module.exports = __webpack_public_path__ + "static/media/Cash_sticker-1.5ac9da54.png";